import * as React from 'react';
import { useField } from 'formik';
import Error from './Error';

export interface IRadioInputValue {
  item: string;
  value: string | number;
  id?: string;
  checked?: boolean;
  item2?: string;
}

interface IRadioInputProps {
  label: string;
  name: string;
  id: string;
  options: IRadioInputValue[];
  placeholder?: string;
  width?: string;
  readonly?: boolean;
  required?: boolean;
  rowOrRows?: string;
  disabled?: boolean;
  className?: string;
  newStyle?: boolean;
  tooltip?: string;
  warningMessage?: string;
  columnClass?: string;
  isGrid?: boolean;
}

const RadioInput: React.FC<IRadioInputProps> = (props) => {
  const [field, meta] = useField(props);
  const rowOrRowsClass = props.rowOrRows === 'rows' ? 'd-block' : 'd-inline-block';
  const rowOrRows = props.rowOrRows ? props.rowOrRows : 'row';

  let errBorder = '';
  if (meta.touched && meta.error) {
    errBorder = 'err-border';
  }

  let radioHeader: JSX.Element = <></>;
  let leftMargin = 'ml-1';
  if (rowOrRows === 'rows') {
    leftMargin = 'ml-5';
    radioHeader = (
      <div className="row">
        <div className={props.width}>
          <div className="text-left control-label">
            <b>
              {props.required && (
                <span className="text-danger text-danger required-field-info">* </span>
              )}
              {props.label}
            </b>
          </div>
        </div>
      </div>
    );
  }
  let radioGroupWidth = '';
  let radioLabel: JSX.Element = <></>;
  if (rowOrRows === 'row') {
    radioGroupWidth = props.width ? props.width : 'col-9';
    radioLabel = (
      <div className="col-3">
        <div className="mt-1">
          <b>
            {props.required && (
              <span className="text-danger text-danger required-field-info">* </span>
            )}
            {props.label}
          </b>
        </div>
      </div>
    );
  }

  const oldStyleContent: JSX.Element = (
    <div>
      {radioHeader}
      <div className="row">
        {radioLabel}
        <div className={radioGroupWidth} title={props.tooltip || ''}>
          {Object.values(props.options).map((option: IRadioInputValue, index: number) => (
            <div className={`${rowOrRowsClass}`} key={option.value} id={option.id}>
              <div className={`mr-3 mb-2 e-radio ${leftMargin}`}>
                <label
                  className="radio"
                  data-cy={`radio-button-${option.value}`}
                  htmlFor={option.id}
                  // onClick={this.handleChangeRadio}
                  data-option-value={option.value}
                  data-disabled-value={props.disabled}
                >
                  <input
                    {...field}
                    type="radio"
                    name={props.name}
                    checked={field.value === String(option.value)}
                    value={String(option.value)}
                    className={props.className || ''}
                    id={`radio-${props.name}-${index}`}
                    disabled={props.disabled}
                  />
                  <span className={`${props.width} pl-5`}>{option.item}</span>
                  {option.item2 && <span className={`${props.width} pl-5`}>{option.item2}</span>}
                </label>
              </div>
            </div>
          ))}
        </div>
        {meta.touched && meta.error && <Error message={meta.error} />}
      </div>
    </div>
  );

  const newStyleContent: JSX.Element = (
    <div
      className={`radio-input-component form-group ${
        meta.touched && meta.error && 'form-group-error'
      }`}
    >
      <div className="row">
        <label className="col-12 col-lg-3 form-label">
          {props.required && <span className="text-danger required-field-info">*</span>}
          {props.label}
        </label>
        <div className="col-12 col-lg-9">
          <div
            className={props.isGrid ? '' : 'row'}
            title={props.tooltip || ''}
            style={
              props.isGrid
                ? {
                    display: 'grid',
                    gridTemplateRows: 'repeat(2, max-content)',
                    gridTemplateColumns: '1fr 1fr',
                  }
                : {}
            }
          >
            {Object.values(props.options).map((option: IRadioInputValue, index: number) => (
              <div
                className={`${props.isGrid ? '' : props.columnClass || 'col-3'}`}
                key={`radio-input-${props.id}-${index}`}
              >
                <div className="e-radio">
                  <label
                    data-cy={`radio-button-${option.value}`}
                    data-option-value={option.value}
                    data-disabled-value={props.disabled}
                    htmlFor={option.id}
                  >
                    <input
                      {...field}
                      type="radio"
                      name={props.name}
                      value={String(option.value)}
                      className={props.className || ''}
                      checked={field.value === String(option.value)}
                      disabled={props.disabled}
                      id={`radio-${props.name}-${index}`}
                    />
                    <span style={{ fontSize: '13px' }}>{String(option.item)}</span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
        {meta.touched && meta.error && <Error message={meta.error} newStyle={true} />}
        {props.warningMessage && <Error message={props.warningMessage} newStyle={true} />}
      </div>
    </div>
  );

  return props.newStyle ? newStyleContent : oldStyleContent;
};

export default RadioInput;
